import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";

function StepCount(props) {
    const InsuffState = useSelector((state) => state?.Insuff);
    const [stepInfo, setStepInfo] = useState({});

    const {activeTab} = props;

    useEffect(() => {
        if (InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails) {
          const activeStep = activeTab === 'personal' ? 1 :Object.entries(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails)
          ?.findIndex(caseInsuff => caseInsuff[1]?.CaseInsuffDetail?.INSUFF_ID === activeTab) + 1; 
          // Personal tab static So other tab step starts with 2
          // const activeStep = activeTab === 'personal' ? 1 : Object.entries(totalGroupsOfChecks)?.find((value, index) => {
          //   console.log('value....',value);
          //   // if(value[1]?.name === activeTab){
          //   //   return index + 2;
          //   // }
          // })
          console.log('activeStep..',activeStep)
          setStepInfo((prevState) => ({
            ...prevState,
            activeStep: activeStep,
            totalStep: Object.entries(InsuffState?.InsuffData?.data?.caseInsuffArr?.insuffDetails).length
          }))
        }
      }, [InsuffState, activeTab]);

    return (
        <>
        {
          stepInfo?.activeStep && <small className="text-muted only-mbl">{`Step ${stepInfo?.activeStep} of ${stepInfo?.totalStep}`} </small>
        }
        </>
    )
}

export default StepCount
